<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Edit offer") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-select-input
            col="6"
            :optionsList="products"
            :placeholder="$t('MESSAGES.Product name')"
            v-model="data.product_id"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Discount percentage')"
            v-model.trim="data.discount_percentage"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Offer start date')"
            v-model.trim="data.start_date"
            required
          />
          <base-input
            col="6"
            type="date"
            :placeholder="$t('MESSAGES.Offer end date')"
            v-model.trim="data.end_date"
            required
          />
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditCity",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      products: [],

      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        active: null,
        product: null,
        start_date: null,
        end_date: null,
        product_id: null,
        discount_percentage: 0,
        image: {
          path: null,
          file: null,
        },
      },

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.name_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar"));
        return;
      } else if (!this.data.name_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en"));
        return;
      } else {
        this.submitForm();
      }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data

      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.product_id) {
        REQUEST_DATA.append("product_id", this.data.product_id?.id);
      }
      if (this.data.discount_percentage) {
        REQUEST_DATA.append(
          "discount_percentage",
          this.data.discount_percentage
        );
      }
      if (this.data.start_date) {
        REQUEST_DATA.append("start_date", this.data.start_date);
      }
      if (this.data.end_date) {
        REQUEST_DATA.append("end_date", this.data.end_date);
      }
      REQUEST_DATA.append("_method", "PUT");
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);
      try {
        await this.$axios({
          method: "POST",
          url: `product-offers/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/product-offers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getProducts() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "products?limit=0&page=0&is_active=1",
        });
        this.products = res.data.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `product-offers/${this.$route.params?.id}`,
        });
        this.data.name_ar = res.data.data.ProductOffer.name_ar;
        this.data.name_en = res.data.data.ProductOffer.name_en;
        this.data.active = res.data.data.ProductOffer.is_active;
        this.data.product_id = res.data.data.ProductOffer.product;
        this.data.discount_percentage =
          res.data.data.ProductOffer.discount_percentage;
        this.data.start_date = res.data.data.ProductOffer.start_date;
        this.data.end_date = res.data.data.ProductOffer.end_date;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.getProducts();
    this.showData();
  },
};
</script>
